import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "../context/AuthContext";
import { useTheme } from "../context/ThemeContext";
import { FaLock, FaUser, FaShieldAlt, FaMoon, FaSun } from "react-icons/fa";
import { BASE_ENDPOINT } from "../helpers/Config";
import axios from "axios";
import toast from "react-hot-toast";

export default function Login() {
  const { login } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios({
        method: "post",
        url: `${BASE_ENDPOINT}/auth/admin-login`,
        maxBodyLength: Infinity,
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          username,
          password,
        },
      });

      const data = response?.data;

      if (data?.error) {
        toast.error(data?.error);
      } else {
        const token = data?.token;
        const msg = data?.msg;

        toast.success(msg);

        localStorage.setItem("iutyeurds", username);
        await login({ token });
        navigate("/", { replace: true });
      }
    } catch (error) {
      console.log(error);
      toast.error("Try again later");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="tb-login-page">
      <button
        type="button"
        className="tb-icon-btn position-fixed"
        style={{ top: 12, right: 12, zIndex: 2 }}
        onClick={toggleTheme}
        aria-label="Toggle theme"
        title={theme === "dark" ? "Light mode" : "Dark mode"}
      >
        {theme === "dark" ? <FaSun /> : <FaMoon />}
      </button>

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
        className="w-100"
        style={{ maxWidth: 400, position: "relative", zIndex: 1 }}
      >
        <div className="text-center mb-3">
          <div className="d-inline-flex align-items-center gap-2 mb-1">
            <span className="tb-brand-mark">TB</span>
            <span className="tb-display" style={{ fontSize: "1.25rem", color: "var(--tb-ink)" }}>
              TradeBid
            </span>
          </div>
          <div className="text-muted small">Operations control panel</div>
        </div>

        <div className="tb-login-card">
          <div className="p-3 p-md-4">
            <div className="d-flex align-items-center gap-2 mb-1">
              <div
                className="d-inline-flex align-items-center justify-content-center"
                style={{
                  width: 34,
                  height: 34,
                  borderRadius: "var(--tb-radius-sm)",
                  background: "var(--tb-accent-soft)",
                  color: "var(--tb-accent)",
                  fontSize: "0.85rem",
                }}
              >
                <FaShieldAlt />
              </div>
              <div>
                <h1 className="h5 mb-0 tb-display">Admin sign in</h1>
                <div className="text-muted small">Authorized operators only</div>
              </div>
            </div>

            <form className="mt-3" onSubmit={onSubmit}>
              <div className="mb-2">
                <label className="form-label small">Username</label>
                <div className="input-group">
                  <span className="input-group-text border-end-0">
                    <FaUser className="text-muted" style={{ fontSize: "0.8rem" }} />
                  </span>
                  <input
                    className="form-control border-start-0"
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Enter username"
                    autoComplete="username"
                    required
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="form-label small">Password</label>
                <div className="input-group">
                  <span className="input-group-text border-end-0">
                    <FaLock className="text-muted" style={{ fontSize: "0.8rem" }} />
                  </span>
                  <input
                    className="form-control border-start-0"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter password"
                    autoComplete="current-password"
                    required
                  />
                </div>
              </div>

              <button className="btn btn-primary w-100" disabled={loading} type="submit">
                {loading ? "Signing in…" : "Sign in"}
              </button>
            </form>
          </div>
        </div>

        <div className="text-center mt-3 small text-muted">
          © {new Date().getFullYear()} TradeBid · Restricted access
        </div>
      </motion.div>
    </div>
  );
}
